export default __webpack_public_path__ + "static/media/scooter.9e3b99bb.png";